<template>
	<div :class="classes">
		<div class="one-on-one-list-card-layout__layout-column one-on-one-list-card-layout__favorite-column">
			<slot name="favorite"></slot>
		</div>
		<div class="one-on-one-list-card-layout__layout-column one-on-one-list-card-layout__layout-column--center">
			<div class="one-on-one-list-card-layout__layout-column one-on-one-list-card-layout__name-column">
				<slot name="name"></slot>
			</div>
			<div class="one-on-one-list-card-layout__layout-column one-on-one-list-card-layout__status-column">
				<slot name="status"></slot>
			</div>
			<div class="one-on-one-list-card-layout__layout-column one-on-one-list-card-layout__role-column">
				<slot name="role"></slot>
			</div>
		</div>
		<div class="one-on-one-list-card-layout__layout-column one-on-one-list-card-layout__chevron-column">
			<slot name="chevron"></slot>
		</div>
	</div>
</template>

<script>

export default {
	name: "OneOnOneListCardLayout",
	props: {
		className: {
			type: String,
			default: "",
		},
	},
	computed: {
		classes() {
			return {
				"one-on-one-list-card-layout": true,
				[ this.className ]: !!this.className,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.one-on-one-list-card-layout {
	display: flex;
	flex-direction: row;
	justify-content: space-evenly;
	align-items: center;

	border: 0.0625rem solid transparent;
	border-radius: 0.5rem;
	box-sizing: border-box;

	padding: 0 1rem;
	height: 3.75rem;

	@include for-size('md') {
		padding: 0 1.6025rem;
	}
}

.one-on-one-list-card-layout__layout-column {
	display: inline-flex;
	flex-direction: row;
	justify-content: flex-start;
}

.one-on-one-list-card-layout__layout-column--center {
	flex: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-evenly;
}

.one-on-one-list-card-layout__favorite-column,
.one-on-one-list-card-layout__chevron-column {
	flex: 3rem;
	justify-content: center;
}

.one-on-one-list-card-layout__favorite-column {
	flex: 2rem;
	justify-content: flex-start;

	@include for-size('md') {
		flex: 3rem;
		justify-content: center;
	}
}

.one-on-one-list-card-layout__chevron-column {
	display: none;

	@include for-size('md') {
		display: inline-flex;
	}
}

.one-on-one-list-card-layout__name-column,
.one-on-one-list-card-layout__status-column,
.one-on-one-list-card-layout__role-column {
	width: 100%;

	@include for-size('sm') {
		width: 50%;
	}

	@include for-size('md') {
		width: 33.33%;
	}
}

.one-on-one-list-card-layout__status-column {
	display: none;

	@include for-size('sm') {
		display: inline-flex;
	}
}

.one-on-one-list-card-layout__role-column {
	display: none;

	@include for-size('md') {
		display: inline-flex;
	}
}
</style>
